import Ants from "@assets/icons/ants.svg?react";
import Article from "@assets/icons/article.svg?react";
import facebook from "@assets/share/facebook.svg";
import telegram from "@assets/share/tg.svg";
import tiktok from "@assets/share/tiktok.svg";
import wechat from "@assets/share/wechat.svg";
import youtube from "@assets/share/youtube.svg";
import type { ReactElement } from "react";

import SocialMedia from "../SocialMedia";

const media = [
  {
    name: "tiktok",
    url: "https://www.tiktok.com/@redants.sg",
    img: tiktok,
  },
  {
    name: "facebook",
    url: "https://www.facebook.com/RedAnts.SG/",
    img: facebook,
  },
  {
    name: "youtube",
    url: "https://www.youtube.com/c/RedAntsSG",
    img: youtube,
  },
  {
    name: "wechat",
    url: "/about-us?ref=footer-page",
    img: wechat,
  },
  {
    name: "telegram",
    url: "https://t.me/redantssg",
    img: telegram,
  },
];

export default function ArticleJoinUs(): ReactElement {
  return (
    <div
      className="box-border flex w-full flex-col overflow-hidden py-4 lg:flex-row"
      data-testid="redants-join"
    >
      <div className="box-border flex w-full flex-col items-center  bg-inverse !p-[20px] max-lg:rounded-t-[8px] lg:w-1/2 lg:rounded-l-[8px]">
        <Ants className="mb-[20px] size-[100px]" />
        <h2 className="mb-[20px] box-border text-center text-header-3 text-primary-on-dark">
          请勿错过我们的更新内容与资讯。
          <br /> 加入我们吧！
        </h2>
        <div className="flex w-full items-center justify-center">
          <SocialMedia
            media={media}
            className="mr-[8px] size-[40px] bg-transparent hover:bg-button-ghost"
          />
        </div>
      </div>
      <div className="box-border flex w-full flex-col items-center  bg-icon-brand p-[20px] max-lg:rounded-b-[8px] lg:w-1/2 lg:rounded-r-[8px]">
        <Article className="m-[20px]" />

        <p className="mb-[8px] text-header-3 text-primary-on-dark">
          想分享你的文章？
        </p>
        <p className="text-subheader text-primary-on-dark">
          <span>请电邮: </span>
          <a
            className="!text-primary-on-dark !no-underline"
            href="mailto:antseditorial@redants.sg"
          >
            antseditorial@redants.sg
          </a>
        </p>
      </div>
    </div>
  );
}
